import { Link, type LinkProps, Outlet, type LinksFunction } from 'react-router'
import instrumentFontStyleSheetUrl from '#app/styles/instrument-font.css?url'
import { cn } from '#app/utils/misc.tsx'
import { Navbar } from './components/navbar'

export const links: LinksFunction = () => {
	return [{ rel: 'stylesheet', href: instrumentFontStyleSheetUrl }]
}

export default function MarketingRoute() {
	return (
		<main className="relative h-[100dvh] bg-slate-50">
			<Navbar />
			<Outlet />
			<Footer />
		</main>
	)
}

function Footer() {
	let currentYear = new Date().getFullYear()
	return (
		<footer className="w-full bg-[#f5f5f7]">
			<div className="mx-auto max-w-[980px] px-6">
				{/* Main footer content */}
				<div className="grid grid-cols-2 gap-x-6 gap-y-8 border-b border-neutral-300/60 py-12 sm:grid-cols-3 lg:grid-cols-6">
					{/* Brand column */}
					<div className="col-span-2 sm:col-span-3 lg:col-span-2">
						<div className="flex items-center gap-2.5">
							<div className="flex h-9 w-9 items-center justify-center rounded-xl bg-neutral-900">
								<img src="/img/logo.png" alt="Ius Pro Logo" className="h-8 w-auto" />
							</div>
							<div className="flex flex-col">
								<span className="text-[15px] font-semibold tracking-tight text-neutral-900">Ius Pro</span>
								<span className="text-[11px] text-neutral-500">Ius Consultores S.A.</span>
							</div>
						</div>
						<p className="mt-4 max-w-[280px] text-[12px] leading-relaxed text-neutral-500">
							Inteligencia artificial diseñada para potenciar el trabajo de profesionales del derecho.
						</p>
						<div className="mt-5">
							<img src="/img/sello.jpg" alt="Sello Pyme" className="h-16 w-auto opacity-90" />
						</div>
					</div>

					{/* Navigation columns */}
					<div>
						<h3 className="mb-3 text-[11px] font-semibold uppercase tracking-wide text-neutral-900">Producto</h3>
						<ul className="space-y-2.5">
							<li>
								<FooterLink to="/producto/auri">Auri</FooterLink>
							</li>
							<li>
								<FooterLink to="/producto/analisis-de-expedientes">Análisis de Expedientes</FooterLink>
							</li>
							<li>
								<FooterLink to="/producto/redaccion-inteligente">Redacción Inteligente</FooterLink>
							</li>
							<li>
								<FooterLink to="/producto/agentes">Agentes</FooterLink>
							</li>
							<li>
								<FooterLink to="/producto/tablas-ia">Tablas IA</FooterLink>
							</li>
							<li>
								<FooterLink to="/producto/revisiones-automaticas">Playbooks</FooterLink>
							</li>
							<li>
								<FooterLink to="/producto/notificaciones-de-la-gaceta">Notificaciones</FooterLink>
							</li>
							<li>
								<FooterLink to="/producto/seguridad">Seguridad</FooterLink>
							</li>
							<li>
								<FooterLink to="/#planes">Precios</FooterLink>
							</li>
						</ul>
					</div>

					<div>
						<h3 className="mb-3 text-[11px] font-semibold uppercase tracking-wide text-neutral-900">Recursos</h3>
						<ul className="space-y-2.5">
							<li>
								<FooterLink to="/articulos">Artículos</FooterLink>
							</li>
							<li>
								<FooterLink to="/guias">Guías</FooterLink>
							</li>
							<li>
								<FooterLink to="/despachos">Para equipos y bufetes</FooterLink>
							</li>
							<li>
								<FooterLink to="/soluciones/abogados-independientes">Abogados independientes</FooterLink>
							</li>
							<li>
								<FooterLink to="/soluciones/departamentos-legales">Departamentos legales</FooterLink>
							</li>
							<li>
								<FooterLink to="/soluciones/notarias">Notarías</FooterLink>
							</li>
						</ul>
					</div>

					<div>
						<h3 className="mb-3 text-[11px] font-semibold uppercase tracking-wide text-neutral-900">Legal</h3>
						<ul className="space-y-2.5">
							<li>
								<FooterLink to="/tos/#">Términos</FooterLink>
							</li>
							<li>
								<FooterLink to="/tos/#privacidad">Privacidad</FooterLink>
							</li>
						</ul>

						<h3 className="mb-3 mt-8 text-[11px] font-semibold uppercase tracking-wide text-neutral-900">Contacto</h3>
						<ul className="space-y-2.5 text-[12px] text-neutral-500">
							<li>
								<FooterLink to="/links/demo" target="_blank">
									Demo
								</FooterLink>
							</li>
							<li>
								<a href="tel:+50660211120" className="transition-colors hover:text-neutral-900">
									+506 6021-1120
								</a>
							</li>
							<li>
								<a href="mailto:soporte@iuspro.com" className="transition-colors hover:text-neutral-900">
									soporte@iuspro.com
								</a>
							</li>
							<li>
								<FooterLink to="/login">Iniciar sesión</FooterLink>
							</li>
						</ul>
					</div>

					<div>
						<h3 className="mb-3 text-[11px] font-semibold uppercase tracking-wide text-neutral-900">Comparativas</h3>
						<ul className="space-y-2.5">
							<li>
								<FooterLink to="/comparacion/chatgpt">vs. ChatGPT</FooterLink>
							</li>
							<li>
								<FooterLink to="/comparacion/lexi">vs. Lexi</FooterLink>
							</li>
							<li>
								<FooterLink to="/comparacion/lexius">vs. LEXIUS</FooterLink>
							</li>
							<li>
								<FooterLink to="/comparacion/tirant">vs. Tirant</FooterLink>
							</li>
							<li>
								<FooterLink to="/comparacion/vlex">vs. vLex</FooterLink>
							</li>
						</ul>
					</div>
				</div>

				{/* Bottom bar */}
				<div className="flex flex-col items-center justify-between gap-2 py-5 text-[11px] text-neutral-500 sm:flex-row">
					<span>Copyright © {currentYear} Ius Consultores S.A. Todos los derechos reservados.</span>
					<span>Costa Rica</span>
				</div>
			</div>
		</footer>
	)
}

function FooterLink(props: LinkProps) {
	return (
		<Link
			{...props}
			className={cn('text-[12px] text-neutral-500 transition-colors hover:text-neutral-900', props.className)}
		>
			{props.children}
		</Link>
	)
}
